(function () {
  'use strict';

  angular.module('datamatic').factory('datamatic', datamaticFactory);

  datamaticFactory.$inject = ['$window'];

  function datamaticFactory($window) {
    if (typeof $window.Datamatic == 'undefined' || !$window.Datamatic) {
      throw new Error("Can't load datamatic.js");
    }

    var datamatic = new $window.Datamatic('106951865504220499962');

    return datamatic;
  }
})();
